/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import AccountTitleDetailEditView from '../../view/pages/account_title/AccountTitleDetailEditView'
import AccountTitleDetailStore from '../../store/account_title/AccountTitleDetailStore'
import AccountTitleOptionsStore from '../../store/options/AccountTitleOptionsStore'
import AccountTitleAction from '../../action/account_title'
import AccountTitleDetailAction from '../../action/account_title_detail'

class AccountTitleDetailEditContainer extends Component {
  static getStores() {
    return [AccountTitleDetailStore, AccountTitleOptionsStore]
  }

  static calculateState(prevState, props) {
    return {
      detail: AccountTitleDetailStore.getState(),
      title_options: AccountTitleOptionsStore.getState(),
      ...props
    }
  }

  componentDidMount() {
    AccountTitleAction.fetchAccountTitles()
    const detailId = this.state.match.params.detail_id
    if (detailId) {
      AccountTitleDetailAction.fetchAccountTitleDetail(detailId)
    }
  }

  render() {
    return AccountTitleDetailEditView(this.state)
  }
}

export default withRouter(Container.create(AccountTitleDetailEditContainer, { withProps: true }))
